import { Tbody, Td, Text, Th, Thead, Tr, Table, Stack } from "@chakra-ui/react";
import {
  KYDContactPurchaseHistory,
  KYDFullContact,
} from "@common/interfaces/KYDCampaign";
import dayjs from "dayjs";
import Dinero from "dinero.js";

export const PurchaseHistoryTable = ({
  data = [],
  ...props
}: {
  data: KYDContactPurchaseHistory[];
}) => {
  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Event</Th>
          <Th w="150px">Order Size</Th>
          <Th>Tickets Purchased</Th>
          <Th>Date</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data
          .sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          )
          .map((item) => {
            return (
              <Tr key={item.event_id}>
                <Td>
                  <Stack spacing={1}>
                    <Text
                      as="a"
                      href={`/events/${item.event_id}`}
                      fontWeight={"medium"}
                      color="black"
                      _hover={{ textDecoration: "underline" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.event_name}
                    </Text>
                    <Text fontSize="small" color="gray.500">
                      {item.event_date}
                    </Text>
                  </Stack>
                </Td>
                <Td>
                  <Text>
                    {Dinero({
                      amount: item.order_size.amount,
                      currency: item.order_size.currency,
                    }).toFormat()}
                  </Text>
                </Td>
                <Td>
                  <Text>{item.tickets_purchased}</Text>
                </Td>
                <Td minW="150px">
                  <Text>{dayjs(item.date).format("MMM D, YYYY h:mm A")}</Text>
                </Td>
              </Tr>
            );
          })}
      </Tbody>
    </Table>
  );
};

export default PurchaseHistoryTable;
